import React from 'react';
import * as classes from './TabsHeader.module.scss';
import cn from 'classnames';
import ArrowIcon from '../../../../../../assets/icons/inline/arrow-top-light.inline.svg';
import { TabInterface, TabsHeaderInterface } from '../../../../../../interfaces/tabs/TabHeader';
import Container from '../../../../../Common/Container/Container';

const TabsHeader = ({ activeTabId, changeTab, items, isVertical, navigation }: TabsHeaderInterface) => {
  const HeaderMapper = (item: TabInterface) => (
    <li key={item.id} onClick={() => changeTab(item.id)} className={cn(classes.item, activeTabId === item.id && classes.active)}>
      {item.label}
    </li>
  );

  const verticalHeaderMapper = (item: TabInterface) => (
    <li key={item.id} onClick={() => changeTab(item.id)} className={cn(classes.item, activeTabId === item.id && classes.active)}>
      {item.label}
      <div className={classes.icon}>
        <ArrowIcon />
      </div>
    </li>
  );

  if (isVertical) {
    return <ul className={classes.verticalWrapper}>{items.map(verticalHeaderMapper)}</ul>;
  }

  return (
    <Container>
      <ul className={classes.wrapper}>{items.map(HeaderMapper)}</ul>
      {navigation && (
        <>
          <div onClick={navigation.nextTab}>next</div>
          <div onClick={navigation.prevTab}>prev</div>
        </>
      )}
    </Container>
  );
};

export default TabsHeader;
